import { render, staticRenderFns } from "./FmInputNew.vue?vue&type=template&id=60d0c86d&"
import script from "./FmInputNew.vue?vue&type=script&lang=js&"
export * from "./FmInputNew.vue?vue&type=script&lang=js&"
import style0 from "./FmInputNew.vue?vue&type=style&index=0&id=60d0c86d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports